const StyledFaqLinkHeading = ({ size, content }) => {
  switch (size) {
    case "h1":
      return <h1>{content}</h1>
    case "h2":
      return <h2>{content}</h2>
    case "h3":
      return <h3>{content}</h3>
    default:
      return <h4 style={{ fontWeight: 300 }}>{content}</h4>
  }
}

export default StyledFaqLinkHeading
